import { isNil } from 'ramda';

export type GridColWidth = number | string | null | undefined;
export type GridColWidths = GridColWidth | Array<GridColWidth> | ((colIndex: number) => GridColWidth);

/**
 * Returns the width of a column by interpreting the column widths property of a grid
 * (defined similarly to Handsontable - see https://handsontable.com/docs/6.2.2/Options.html#colWidths)
 *
 * @param colWidths The column widths property
 * @param colIndex
 * @return Width of the column
 */
const getColWidth = (colWidths: GridColWidths, colIndex: number): number | string => {
  if (isNil(colWidths)) return DEFAULT_WIDTH;
  if (typeof colWidths === 'number') return colWidths;
  if (typeof colWidths === 'string') return colWidths === '' ? DEFAULT_WIDTH : colWidths;
  if (typeof colWidths === 'function') return getColWidth(colWidths(colIndex), colIndex);

  if (Array.isArray(colWidths)) {
    const width = colWidths[colIndex];
    return getColWidth(width, colIndex);
  }

  throw new Error(`Attempted to get column width from an unsupported type. Value was "${colWidths}".`);
};

export const DEFAULT_WIDTH = 150;
export default getColWidth;
